import { Facet } from '../../models/Facet';
import { IOperationActionCreator, implementOperation } from '../../store/actions/implementOperation';

export const cancelProgressItemsOperation: Facet<{}> = new Facet('cancelProgressItemsOperation');

/**
 * Creates an action which, when dispatched, cancels specified progress items
 * in manners specific to the given progress item types.
 */
export const cancelProgressItems: IOperationActionCreator<typeof cancelProgressItemsOperation.type> = implementOperation({
  operationTypeFacet: cancelProgressItemsOperation
});
